/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type PostCollaborationToolTemplateRequestDto = {
    type: PostCollaborationToolTemplateRequestDto.type;
};

export namespace PostCollaborationToolTemplateRequestDto {

    export enum type {
        JIRA = 'JIRA',
        SERVICENOW = 'SERVICENOW',
    }


}
